import type { AvatarProps } from '@hotjar/hotsauce';
import { Avatar } from '@hotjar/hotsauce';
import type { ForwardedRef } from 'react';
import { forwardRef } from 'react';
import { RoundButton } from '../RoundButton';

export const AvatarButton = forwardRef<HTMLElement, Pick<AvatarProps, 'userName' | 'src'>>(
  ({ userName, src }: Pick<AvatarProps, 'userName' | 'src'>, ref): JSX.Element => {
    return (
      <RoundButton ref={ref as ForwardedRef<HTMLButtonElement>}>
        <Avatar size="l" userName={userName} src={src} />
      </RoundButton>
    );
  },
);

AvatarButton.displayName = 'AvatarButton';
